import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center mb-4" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "My Dependents")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " The displayed information is from your records with the Fund Office. If the information is not correct, click on the applicable dependent in order to update. If you wish to add a new dependent, click the button on the lower right side of your screen. ", -1)
const _hoisted_6 = { class: "row d-flex justify-content-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary col-md-2",
  onclick: "window.history.back()"
}, "Back", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary col-md-2" }, " View My Beneficiaries ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DependentsTable = _resolveComponent("DependentsTable")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_DependentsTable, {
            dependents: $setup.dependents,
            headers: $setup.headers
          }, null, 8, ["dependents", "headers"]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_router_link, {
              to: { name: 'add-dependent' },
              class: "btn btn-secondary col-md-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Add New Dependents ")
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}